export default __webpack_public_path__ + "static/media/LeasePlan-Bold.441296e0.woff";